import {
    PiBriefcaseDuotone,
    PiCakeDuotone,
    PiClockDuotone,
    PiCoffeeDuotone,
    PiCoinsDuotone,
    PiGraduationCapDuotone,
    PiIdentificationCardDuotone,
    PiPlayCircleDuotone,
    PiQuestionDuotone,
    PiStudentDuotone,
    PiUserPlusDuotone,
} from 'react-icons/pi';
import { Link } from 'react-router-dom';

import ExpandableCardList from 'elements/ExpandableCardList';
import PageHeading from 'elements/PageHeading';
import Pattern from 'elements/Pattern';

const GENERAL_FAQ_ITEMS = [
    {
        title: <><span className='hidden sm:inline'>Még nem</span><span className='sm:hidden'>Nem</span> vagyok Fürge Diák</>,
        description: 'Itt megtudhatod, hogyan tudsz regisztrálni és belépni a Fürge Diák Iskolaszövetkezetbe. Összegyűjtöttük, milyen feltételeknek kell megfelelned, és milyen dokumentumokat érdemes magaddal hoznod.',
        Icon: PiUserPlusDuotone,
        Content: NewStudentContent,
        id: 'new-student',
    },
    {
        title: 'Már Fürge Diák vagyok',
        description: 'Ez a rész azoknak szól, akik már tagjai a Fürge Diáknak, és munkát szeretnének vállalni. Segít eligazodni abban, hogyan igazolhatod az aktuális nappali tagozatos jogviszonyodat.',
        Icon: PiIdentificationCardDuotone,
        Content: MemberContent,
        id: 'member',
    },
    {
        title: 'A minimálbérről',
        description: 'Itt röviden összefoglaljuk, mit jelent a minimál órabér a diákmunkák esetében. Azt is megtudhatod, miért lehet magasabb a tényleges óradíjad annál, ami az alapmegállapodásban szerepel.',
        Icon: PiCoinsDuotone,
        Content: MinimumWageContent,
        id: 'minimum-wage',
    },
    {
        title: 'Gyakori kérdések',
        description: 'Ebben a részben a diákmunkával, tagsággal, fizetéssel és jelentkezéssel kapcsolatos leggyakoribb kérdésekre válaszolunk. Ha gyors eligazításra van szükséged, érdemes itt kezdened.',
        Icon: PiQuestionDuotone,
        Content: FrequentlyAskedContent,
        id: 'frequently-asked',
    },
];

const MEKI_FAQ_ITEMS = [
    {
        title: 'Gondot jelent, ha még sose vállaltam diákmunkát?',
        Icon: PiBriefcaseDuotone,
        Content: MekiFirstJobContent,
        id: 'meki-first-job',
    },
    {
        title: 'Kiszámítható és rugalmas a munkaidő a Mekinél?',
        Icon: PiClockDuotone,
        Content: MekiScheduleContent,
        id: 'meki-schedule',
    },
    {
        title: 'Hogyan kezdhetek el a Mekiben dolgozni?',
        Icon: PiPlayCircleDuotone,
        Content: MekiStartContent,
        id: 'meki-start',
    },
    {
        title: 'Hány éves kortól dolgozhatok Mekiben?',
        Icon: PiCakeDuotone,
        Content: MekiAgeContent,
        id: 'meki-age',
    },
    {
        title: 'A minimálbérről',
        Icon: PiCoinsDuotone,
        Content: MinimumWageContent,
        id: 'meki-minimum-wage',
    },
    {
        title: 'GYIK',
        Icon: PiQuestionDuotone,
        Content: FrequentlyAskedContent,
        id: 'meki-frequently-asked',
    },
];

const INTERNSHIP_FAQ_ITEMS = [
    {
        title: 'Első évesként is jelentkezhetek gyakornoki munkára?',
        Icon: PiGraduationCapDuotone,
        Content: InternshipFirstYearContent,
        id: 'internship-first-year',
    },
    {
        title: 'Középiskolásként is dolgozhatok gyakornokként?',
        Icon: PiStudentDuotone,
        Content: InternshipSecondarySchoolContent,
        id: 'internship-secondary-school',
    },
    {
        title: 'Mennyire rugalmas a gyakornokság?',
        Icon: PiClockDuotone,
        Content: InternshipScheduleContent,
        id: 'internship-schedule',
    },
    {
        title: 'Hogyan kezdhetek el dolgozni gyakornokként?',
        Icon: PiPlayCircleDuotone,
        Content: InternshipStartContent,
        id: 'internship-start',
    },
    {
        title: 'Kávéfőzésből és iratrendezésből fognak állni a napjaim?',
        Icon: PiCoffeeDuotone,
        Content: InternshipTasksContent,
        id: 'internship-tasks',
    },
    {
        title: 'A minimálbérről',
        Icon: PiCoinsDuotone,
        Content: MinimumWageContent,
        id: 'internship-minimum-wage',
    },
    {
        title: 'GYIK',
        Icon: PiQuestionDuotone,
        Content: InternshipFrequentlyAskedContent,
        id: 'internship-frequently-asked',
    },
];

const FAQ_VARIANTS = {
    general: {
        title: 'Ezeket jó tudni a diákmunkáról',
        subTitle: <div className='text-sm leading-relaxed text-white/90 sm:text-base'>Hogyan tudsz diákmunkát vállalni? Mire van szükség ahhoz, hogy te is Fürge Diák legyél? Itt megtalálod a legfontosabb tudnivalókat.<br /><br />Ha maradt kérdésed, nézz körül a <Link className='font-bold transition hover:decoration-white' to='/blog'>blogunkban</Link> is!</div>,
        items: GENERAL_FAQ_ITEMS,
        className: 'gradient-blue',
    },
    meki: {
        title: 'Ezeket jó tudni a Mekis diákmunkáról',
        subTitle: 'Ismerd meg a legfontosabb információkat a Mekis diákmunka vállalásáról!',
        items: MEKI_FAQ_ITEMS,
        className: 'bg-gradient-to-br from-red-800 via-red-700 to-amber-600',
    },
    internship: {
        title: 'Gyakori kérdések a gyakornokságról',
        subTitle: 'A legfontosabb tudnivalók a gyakornokságról',
        items: INTERNSHIP_FAQ_ITEMS,
        className: 'bg-gradient-to-br from-orange-700 via-orange-600 to-amber-500',
    },
};

export default function FaqPage({ variant = 'general', className = '' }) {
    const config = FAQ_VARIANTS[variant] || FAQ_VARIANTS.general;

    return (
        <main className={`relative flex w-full flex-1 flex-col items-center overflow-hidden px-site py-site ${config.className} ${className}`}>
            <Pattern />
            <div className='z-10 mx-auto flex w-full max-w-boxed flex-col gap-10 md:gap-14'>
                <PageHeading title={config.title} subTitle={config.subTitle} />
                <ExpandableCardList items={config.items} renderContent={renderFaqContent} />
            </div>
        </main>
    );
}

function renderFaqContent({ Content }) {
    return (
        <div className='text-xs leading-relaxed text-neutral-700 sm:text-sm sm:leading-loose [&_a]:font-bold [&_a]:text-sky-700 [&_a:hover]:underline [&_b]:font-display [&_b]:text-base [&_b]:text-neutral-900 [&_strong]:font-display [&_strong]:text-base [&_strong]:text-neutral-900'>
            <Content />
        </div>
    );
}

function NewStudentContent() {
    return <>
        Találtál weboldalunkon olyan munkát, amit szívesen elvállalnál?<br />
        Akkor mindenekelőtt regisztrálj hozzánk<Link className='font-bold hover:underline' to='/regisztracio'> ide kattintva!</Link><br />
        A regisztrációt követően kollégánk felveszi veled a kapcsolatot, és minden részletet megoszt veled a munkavállalás menetével kapcsolatban.<br /><br />
        <MembershipRequirementsContent />
    </>;
}

function MembershipRequirementsContent() {
    return <>
        A munkavállaláshoz a regisztrációt követően a Fürge Diák Iskolaszövetkezet tagjává kell válnod.<br />
        Tag úgy lehetsz, ha a szövetkezeti vagyoni hozzájárulást megfizeted. Ez egyszeri 1.000 Ft-ot jelent, melyet úgy alakítottunk ki, hogy nem a belépéskor kell megfizetned, hanem csak az első fizetésedből vonjuk le. Ez az összeg nem tagdíj, és ilyet nem is kérünk a diákjainktól.<br />
        Ha kilépsz a Fürge Diák Iskolaszövetkezetből, akkor az 1.000 Ft-ot visszautaljuk neked.<br /><br />
        <b>A belépésnek az alábbi feltételei vannak:</b><br />
        1. Rendelkezel nappali tagozatos hallgatói jogviszonnyal. Ezt igazolhatod diákigazolvánnyal, diákigazolvány igényléséről szóló igazolással, diákigazolvány helyett kiállított igazolással vagy iskolalátogatási igazolással.<br />
        2. Betöltötted 15. életévedet, a belépéshez pedig (18 éves életkor alatt) szülő vagy törvényes képviselőd hozzájárul.<br />
        3. Kitöltötted a Belépési nyilatkozatot.<br />
        4. A szövetkezeti vagyoni hozzájárulást megfizeted.<br /><br />
        Az egyes igazolásokkal kapcsolatos tudnivalókról kérdezd kollégánkat!<br />
        Adott időszakra szóló jogviszony igazolás hiányában nem állhatsz munkába.<br /><br />
        Diákmunka 18 év alatt csak szülői vagy törvényes képviselő hozzájárulásával lehetséges.<br />
        Diákmunka 16 év alatt csak akkor lehetséges, ha már betöltötted 15. életévedet és tanítási szünet (őszi-, téli-, tavaszi- és nyári szünet) alatt dolgoznál. De ekkor is szükséges szülő vagy törvényes képviselő hozzájárulása.<br />
        Diákmunkát nem végezhetnek azok a diákok, akik még nem töltötték be 15. életévüket.<br /><br />
        <b>A Fürge Diák Iskolaszövetkezetbe belépni csak személyesen, az irodáink egyikén lehet!</b><br /><br />
        <b>A belépéshez ezeket hozd magaddal:</b><br />
        1. Aktuális félévre szóló nappali tagozatos hallgatói jogviszony igazolás<br />
        2. Diákigazolvány<br />
        3. Adóazonosító jel<br />
        4. Társadalombiztosító azonosító jel (TAJ kártya)<br />
        5. Egyéb fényképes igazolvány (személyi igazolvány, útlevél vagy jogosítvány)<br />
        6. Saját névre szóló bankszámlaszám<br /><br />
        <b>A belépéssel egy időben személyes közreműködésről szóló megállapodást kötünk veled, és munkabaleset esetére is biztosítottá válsz.</b><br />
        Ezt követően már válogathatsz is munkalehetőségeink között…
    </>;
}

function MemberContent() {
    return <>
        Ne feledd, hogy csak azokban az időszakokban tudsz diákmunkát vállalni, amikorra nappali tagozatos jogviszonyodat igazoltad!<br /><br />
        <StudentStatusDocuments />
        <b>Még nem adtad le igazolásodat az aktuális időszakra? Esetleg kérdésed van az egyes igazolásokkal kapcsolatos tudnivalókról? Keresd projektvezetődet!</b>
    </>;
}

function StudentStatusDocuments() {
    return <>
        <b>Jogviszonyodat az alábbi dokumentumokkal igazolhatod:</b><br />
        1. Diákigazolvánnyal<br />
        2. Diákigazolvány igényléséről szóló igazolással<br />
        3. Diákigazolvány helyett kiállított igazolással<br />
        4. Iskolalátogatási igazolással<br /><br />
        Figyelem! Az egyes igazolások eltérő időintervallumban igazolják a nappalis jogviszonyt!<br /><br />
    </>;
}

function MinimumWageContent() {
    return <>
        A belépéskor aláírt tagi megállapodásban, az alapdíjnál minden esetben a kormány által meghatározott minimál órabér van megjelölve.<br /><br />
        <b>2026. évben a minimál órabér összege bruttó 1856 Ft/óra</b><br /><br />
        Partnereink egy része azonban ennél magasabb bruttó órabért fizet a diákoknak. Ezért ne lepődj meg, ha esetleg munkatársunk magasabb óradíjat mond neked a munkavállalás egyeztetésekor! A végleges óradíjad az lesz, amit munkatársunk mond neked.<br /><br />
        <b>Az alapdíjat növelő összegeket mindig az úgynevezett Eseti megállapodásban részletezzük és írásban rögzítjük.</b>
    </>;
}

function FrequentlyAskedContent() {
    return <>
        <b>Mi a különbség a regisztráció és a tagság között?</b><br />
        A regisztráció munkavállalási szándékod jelzése, amelynek segítségével a weben keresztül értesítesz minket, hogy szeretnél dolgozni. A regisztráció során megadhatsz nekünk olyan információkat, hogy mely irodáinknál szeretnél munkát vállalni, milyen jellegű munkák érdekelnek, vagy mikor érsz rá dolgozni.<br />
        A szövetkezet tagja az, akivel személyes közreműködésről szóló megállapodással és belépési nyilatkozattal jogviszonyt hoztunk létre. Ez irodáinkon személyesen tehető meg.<br /><br />
        <b>Mit tehetek azért, hogy munkához jussak?</b><br />
        Rengeteg regisztrációt és jelentkezést kapunk nap mint nap. Ezért néha lassabban tudjuk veled felvenni a kapcsolatot. Ha munkavállalási szándékod komoly, nyugodtan keress minket telefonon vagy online elérhetőségeinken! De szívesen látunk irodáinkon is!<br /><br />
        <b>Mi az a nettó és a bruttó díj?</b><br />
        A bruttó díj az a díj, melyből még semmilyen adó és járulék nem került levonásra. A nettó díj a jogszabályban meghatározott adó- és járuléklevonást követő díj. Hétköznapi nyelven: a nettó az az összeg, melyet a bankszámládra utalunk az általad végzett munkáért.<br />
        A diákmunka adózása eltérő adózási kötelezettséggel rendelkezik, erről bővebben <Link className='font-bold hover:underline' to='/blog'>blogunkon</Link> olvashatsz.<br /><br />
        <b>Szakmai gyakorlatot tudom-e rajtatok keresztül tölteni?</b><br />
        Igen! Ha van olyan hely, ahol biztosan fogadnak, mi segítünk abban, hogy iskolaszövetkezeti tagként dolgozhass. De szétnézhetsz <Link className='font-bold hover:underline' to='/diakmunka?munkakor=5'>gyakornoki programunk</Link> ajánlatai között is.<br /><br />
        <b>Hogyan ismerhetem meg a rám vonatkozó jogszabályokat?</b><br />
        <Link className='font-bold hover:underline' to='/blog'>Blogunkban</Link> részletesen foglalkozunk a diákokra vonatkozó jogszabályokkal.<br />
        Emellett 2011 óta évről évre elkészítjük <Link className='font-bold hover:underline' to='/jo-tudni'>Munkaerő-piaci kalauzunkat</Link>, melyből megismerheted a munkavégzéshez kötődő jogaidat és kötelezettségeidet. Tájékoztató füzetünket megtalálod irodáinkon, de kollégáinktól kérheted, hogy vegyük fel a kapcsolatot iskoláddal, osztályfőnököddel, és egy rendhagyó osztályfőnöki óra keretében mutassuk be neked és osztálytársaidnak a munka világát.<br /><br />
        <b>Másik városba költözök, ott is tudok Fürgésként dolgozni?</b><br />
        Igen! A Fürge Diák Iskolaszövetkezet országos lefedettséggel rendelkezik. Egy tagsággal az ország bármely pontján vállalhatsz munkát.<br /><br />
        <b>Szívesen dolgoznék a Fürge Diák irodájában, hogyan tudok jelentkezni hozzátok?</b><br />
        Előre szólunk, hogy az általunk végzett munka ambíciót, felelősség- és minőségtudatot igényel. Önállóságra és precíz munkavégzésre is szükség van ahhoz, hogy minden diákunk érdekét és minden partnerünk igényét egyszerre tudjuk teljesíteni. Ha szívesen vennél részt ebben, keresd meg a kiszemelt irodát e-mailen vagy telefonon. Az önéletrajzodra biztosan szükségünk lesz! ;)
    </>;
}

function MekiFirstJobContent() {
    return <>
        Egyáltalán nem gond, ha még nem dolgoztál diákként.<br /><br />
        A Meki olyan gyorsétterem, ami szuper első munkahely. Rengeteg dolgot megtanulhatsz úgy, hogy segítőkész csapat és mentor program áll mögötted. Az étteremben mindent megtanítanak neked, és sose maradsz egyedül a nehézségekkel.<br /><br />
        Hiszünk a csapatmunkában, kérdéseiddel vagy a felmerült problémákkal nem csak az éttermi csapathoz fordulhatsz, hanem a Fürge Diák irodáiban dolgozó kollégáinkhoz is.
    </>;
}

function MekiScheduleContent() {
    return <>
        A Meki az egyik legrugalmasabb munkáltató, aki a diák és a nem diák munkavállalóknak is biztosítja a lehetőséget, hogy munkaidejüket saját igényeikhez igazíthassák.<br /><br />
        A munkarendedet előre leegyeztetik veled az étterem vezetői, így könnyedén tudod a sulihoz vagy egyéb kötelezettségeidhez igazítani a diákmunkát. Ráadásul 4, 6 és 8 órás műszakokban is gondolkozhatsz, és hétköznap, valamint hétvégén is vállalhatsz munkát. Azzal azonban számolnod kell, hogy heti legalább 16 órát teljesítened kell.<br /><br />
        A pontos részleteket szívesen elmondjuk neked, ha írsz nekünk vagy felhívsz minket!
    </>;
}

function MekiStartContent() {
    return <>
        A folyamat rendkívül egyszerű, és ha minden flottul megy, akkor akár már a jelentkezésed után egy héttel kezdhetsz a kiválaszott Meki étteremben. 😊<br /><br />
        <b>Ha már Tagja vagy a Fürge Diák Iskolaszövetkezetnek</b>, akkor válaszd ki munkaajánlataink közül azt a lehetőséget, ami a legszimpatikusabb neked, és kattints a munka leírása végén található jelentkezés gombra!<br /><br />
        Ne feledd, hogy csak azokban az időszakokban tudsz diákmunkát vállalni, amikorra nappali tagozatos jogviszonyodat igazoltad!<br /><br />
        <StudentStatusDocuments />
        <b>Ha még nem vagy Fürge Diák tag</b>, akkor mindenekelőtt regisztrálj hozzánk <Link className='font-bold hover:underline' to='/regisztracio'>ide kattintva!</Link><br />
        A regisztrációt követően kollégánk felveszi veled a kapcsolatot, és minden részletet megoszt veled a munkavállalás menetével kapcsolatban.<br /><br />
        <MembershipRequirementsContent /><br /><br />
        Kollégáink minden esetben felkeresnek téged, hogy átbeszéljétek a további részleteket.
    </>;
}

function MekiAgeContent() {
    return <>
        A Mekis diákmunkáknál is érvényes, hogy csak 15 éves kortól vállalható. Továbbá igaz az is, hogy ha még nem töltötted be a 16. életévedet, akkor csak iskolai szünetben (őszi-, téli-, tavaszi- és a nyári szünetekben) dolgozhatsz.<br /><br />
        A Meki a szünidőben örömmel fogadja a 15 éves diákokat is, nem kell tehát megvárnod, hogy betöltsd a 16-ot.<br /><br />
        Fontos azonban tudnod, hogy ha 18 év alatt vagy, akkor a diákmunka vállalásához a törvényes képviselődnek (szülőnek) is alá kell írnia a munkavállaláshoz tartozó szerződésedet. Enélkül sajnos nem tudunk neked munkát adni.
    </>;
}

function InternshipFirstYearContent() {
    return <>Igen, már egy lezárt félévvel rendelkező hallgatókat is várnak Partnereink.</>;
}

function InternshipSecondarySchoolContent() {
    return <>Sajnos nem, gyakornoki pozícióban mindenképpen szükséges felsőfokú tanulmányok folytatása.</>;
}

function InternshipScheduleContent() {
    return <>Általában nagyon órarendbarát minden pozíció. Heti minimum 20 órát teljesíteni kell, de a céggel közösen meghatározott, rugalmas beosztásban.</>;
}

function InternshipStartContent() {
    return <>Hogyha felsőfokú tanulmányokat folytatsz és egy félévet már sikeresen teljesítettél, akkor a honlapunkon található lehetőségekre az önéletrajzod küldésével tudsz jelentkezni.</>;
}

function InternshipTasksContent() {
    return <>Kávét főznöd csak magadnak kell majd, ha szereted. A gyakornoki pozíciókban szakmai és komplex feladatkörökbe látsz bele. Amint már magabiztos vagy a feladatokban, nem csak figyelni és tanulni fogsz, hanem elvégezni ezeket a feladatokat.</>;
}

function InternshipFrequentlyAskedContent() {
    return <>
        <strong>Mi a különbség a regisztráció és a tagság között?</strong><br /><br />
        A weboldalon történő regisztráció munkavállalási szándékod jelzése, amelynek segítségével keresztül értesítesz minket, hogy szeretnél dolgozni. A regisztráció során megadhatsz nekünk olyan információkat, hogy mely településen szeretnél munkát vállalni, milyen jellegű munkák érdekelnek, vagy mikor érsz rá dolgozni. Az Iskolaszövetkezet tagja az, akivel személyes közreműködésről szóló megállapodással és belépési nyilatkozattal jogviszonyt hoztunk létre.<br /><br />
        <strong>Mit tehetek azért, hogy munkához jussak?</strong><br /><br />
        Többféle módon jelentkezhetsz hozzánk. <Link to='/regisztracio'>Weboldalunkon</Link> regisztrálhatsz vagy <Link to='/diakmunka'>konkrét állásra jelentkezhetsz</Link>, felkereshetsz minket telefonon vagy e-mailen keresztül és szívesen látunk irodáinkban is!<br /><br />
        <strong>Mi az a nettó és a bruttó díj?</strong><br /><br />
        A bruttó díj az a díj, melyből még semmilyen adó és járulék nem került levonásra. A nettó díj a jogszabályban meghatározott adó- és járuléklevonást követő díj. Hétköznapi nyelven: a nettó az az összeg, melyet a bankszámládra utalunk az általad végzett munkáért. A diákmunka adózásáról bővebben <Link to='/blog'>Blogunkon</Link> olvashatsz.<br /><br />
        <strong>Hogyan ismerhetem meg a rám vonatkozó jogszabályokat?</strong><br /><br />
        <Link to='/blog'>Blogunkban</Link> részletesen foglalkozunk a diákokra vonatkozó jogszabályokkal. Emellett 2011 óta évről-évre elkészítjük Munkaerő-piaci kalauzunkat, melyből megismerheted a munkavégzéshez kötődő jogaidat és kötelezettségeidet. Tájékoztató füzetünket megtalálod irodáinkon.<br /><br />
        <strong>Másik városba költözök, ott is tudok Fürgésként dolgozni?</strong><br /><br />
        Igen! A Fürge Diák Iskolaszövetkezet országos lefedettséggel rendelkezik. Egy tagsággal az ország bármely pontján vállalhatsz munkát.<br /><br />
        <strong>Szívesen dolgoznék a Fürge Diák irodájában, hogyan tudok jelentkezni hozzátok?</strong><br /><br />
        Előre szólunk, hogy az általunk végzett munka ambíciót, felelősség- és minőségtudatot igényel. Önállóságra és precíz munkavégzésre is szükség van ahhoz, hogy minden diákunk érdekét és minden partnerünk igényét egyszerre tudjuk teljesíteni. Ha szívesen vennél részt ebben, keresd meg a kiszemelt irodát e-mailen vagy telefonon. Az önéletrajzodra biztosan szükségünk lesz!
    </>;
}
